import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import { IntakeInquiryForm } from "../components/employer/IntakeInquiryForm";
import { ArrowLeft } from "lucide-react";

/**
 * Non-paid intake inquiry entry point.
 * Route: /employers/intake
 */
export default function EmployerIntakePage() {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="employer-intake-page">
      <SiteHeader />
      <main className="py-12 lg:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/employers"
            className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6 transition-colors"
            data-testid="employer-intake-back-link"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to For Employers
          </Link>
          <header className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              Request your Employer Intake Package
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              We&apos;ll review your inquiry and follow up with a tailored proposal.
            </p>
          </header>
          <IntakeInquiryForm />
        </div>
      </main>
    </div>
  );
}
